import { resetSelectedRole, roleSelectError, setSelectedRole } from "./reducer";

export const setUserSelectedRole = (user:any)=> async (dispatch:any)=>{
   try {
        dispatch(setSelectedRole(user));
    } catch (error:any) {
        dispatch(roleSelectError(error?.message))
        
    }
}

export const resetUserSelecteRole = ()=> async (dispatch:any)=>{
    try {
        dispatch(resetSelectedRole())
    } catch (error:any) {
        dispatch(roleSelectError(error?.message))
    }
}